import React, { useEffect, useState } from 'react';
import { Api } from '../../logic/Api/Api';
import { sleepOnIt } from '../../logic/Utility/Utils';

interface IGetJdConnectPollResponse
{
	InvitationStatus?: string;
    IsConnected?: boolean;
	JdConnectionsUrl?: string;
}

/**
 * Fetch an invitation's details from the server
 */
export function useGetJdConnectPoll(
	invitationCode: string, 
	api: Api, 
	setMessage: (message:React.ReactNode) => unknown,
	setStatus: (status:string) => unknown,
	startLoading: () => void, 
	endLoading: () => void,
	setJdConnectUrl: (value: string) => void,
	shouldPoll: boolean)
{
	startLoading();
	async function exec()
	{
		try 
		{
			// Poll until complete or errored
			let status = '';
			let pollResponse = null;
			while (status != 'Connected')
			{
				await sleepOnIt(1000);
				pollResponse = await api.getUnauthorizedAsync<IGetJdConnectPollResponse>(`6/jd-connect/invitations/${invitationCode}/pollJdConnection`);

				if (!pollResponse.Success) 
				{
					setMessage(<>{pollResponse.ErrorMessage}</>);
					return;
				}
				else if (pollResponse.Success)
				{
					const data = pollResponse.Data as IGetJdConnectPollResponse;

					if (data.InvitationStatus === 'ConnectionPending')
					{
						setJdConnectUrl(data.JdConnectionsUrl);
					}
	
					setStatus(data.InvitationStatus);
					status = data.InvitationStatus;

					if (!shouldPoll)
					{
						endLoading();
						return;
					}
				}
			}

			endLoading();
			return pollResponse;
		}
		catch (err) 
		{
			setMessage(<>An unknown error occurred. Please try again later.</>);
		}
	}
	exec();
}